import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "modal-msg-handler",
  class: "modal"
}
const _hoisted_2 = { class: "modal__content" }
const _hoisted_3 = { class: "p-5 text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-3xl mt-5 t-msg" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 mt-2 c-msg" }, null, -1)
const _hoisted_6 = { class: "px-5 pb-8 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_xCircleIcon = _resolveComponent("xCircleIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CheckCircleIcon, { class: "w-16 h-16 text-theme-9 mx-auto mt-3 hidden ic-s" }),
        _createVNode(_component_xCircleIcon, { class: "w-16 h-16 text-theme-6 mx-auto mt-3 hidden ic-e" }),
        _hoisted_4,
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          "data-dismiss": "modal",
          class: "button w-24 bg-theme-1 text-white",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.okeHide()))
        }, " Ok ")
      ])
    ])
  ]))
}